import { AlertProps } from "@gravity-ui/uikit";
import { atom } from "@reatom/framework";

export const notificationAtom = atom<Pick<AlertProps, "message" | "theme">>({
  theme: "info",
  message: "",
});
